(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};

function createTemplate() {
    return [
      '<div class="sbb-shell">',
      '  <div class="sbb-top-shelf">',
      '    <div class="sbb-top-brand">',
      '      <div class="sbb-brand-hero" data-sbb="brand-hero" aria-label="Scale Bar Designer">',
      '        <span class="sbb-brand-text" data-sbb="brand-text"><span class="sbb-brand-line">Scale Bar</span><span class="sbb-brand-line">Designer</span></span>',
      '        <img class="sbb-brand-logo" data-sbb="brand-logo" alt="Scan Space" />',
      '      </div>',
      '    </div>',
      '    <div class="sbb-top-shelf-stack">',
      '    <div class="sbb-main-shelf" data-sbb="main-shelf">',
      '      <div class="sbb-main-shelf-top">',
      '        <div class="sbb-top-action-group">',
      '          <select class="sbb-template-select" data-sbb="template-select"><option value="">Load Template</option></select>',
      '          <button type="button" class="sbb-button small xs" data-sbb="load-template">Load</button>',
      '        </div>',
      '        <button type="button" class="sbb-button small xs" data-sbb="reset-session">Reset Scene</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="share-session">Share</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="start-guide">Guide</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="start-guide-in-depth">In-Depth</button>',
      '        <span class="sbb-toolbar-divider" aria-hidden="true"></span>',
      '        <button type="button" class="sbb-button small xs" data-sbb="undo">Undo</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="redo">Redo</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="copy-entity">Copy</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="paste-entity">Paste</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="duplicate-entity">Duplicate</button>',
      '        <span class="sbb-toolbar-divider" aria-hidden="true"></span>',
      '        <button type="button" class="sbb-button small xs" data-sbb="zoom-out">-</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="zoom-reset">100%</button>',
      '        <button type="button" class="sbb-button small xs" data-sbb="zoom-in">+</button>',
      '      </div>',
      '    </div>',
      '    <div class="sbb-tools-strip">',
      '      <div class="sbb-preview-toolbar">',
      '        <div class="sbb-toolbar-toggle">',
      '          <button type="button" class="sbb-button small xs" data-sbb="open-advanced">Hide Settings</button>',
      '          <span class="sbb-toolbar-divider" aria-hidden="true"></span>',
      '        </div>',
      '        <div class="sbb-toolbar-group">',
      '          <span class="sbb-toolbar-label">Tools</span>',
      '          <button type="button" class="sbb-button small" data-sbb="add-reference">Reference</button>',
      '          <button type="button" class="sbb-button small" data-sbb="add-text">Text</button>',
      '          <button type="button" class="sbb-button small" data-sbb="add-image">Image</button>',
      '          <button type="button" class="sbb-button small" data-sbb="add-tag">Tag</button>',
      '          <select class="sbb-select xs" data-sbb="add-shape-kind"></select>',
      '          <button type="button" class="sbb-button small" data-sbb="add-shape">Shape</button>',
      '        </div>',
      '        <div class="sbb-toolbar-group">',
      '          <span class="sbb-toolbar-label">Noise</span>',
      '          <button type="button" class="sbb-button small" data-sbb="toggle-background-noise">Noise Off</button>',
      '          <button type="button" class="sbb-button small" data-sbb="noise-settings" title="Noise settings" aria-label="Noise settings"><svg class="sbb-icon sbb-icon-cog" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10.325 4.317a1.724 1.724 0 0 1 3.35 0a1.724 1.724 0 0 0 2.573 1.066a1.724 1.724 0 0 1 2.898 1.675a1.724 1.724 0 0 0 1.507 2.192a1.724 1.724 0 0 1 0 3.5a1.724 1.724 0 0 0-1.507 2.192a1.724 1.724 0 0 1-2.898 1.675a1.724 1.724 0 0 0-2.573 1.066a1.724 1.724 0 0 1-3.35 0a1.724 1.724 0 0 0-2.573-1.066a1.724 1.724 0 0 1-2.898-1.675a1.724 1.724 0 0 0-1.507-2.192a1.724 1.724 0 0 1 0-3.5a1.724 1.724 0 0 0 1.507-2.192a1.724 1.724 0 0 1 2.898-1.675a1.724 1.724 0 0 0 2.573-1.066ZM12 15.1a3.1 3.1 0 1 0 0-6.2a3.1 3.1 0 0 0 0 6.2Z"></path></svg></button>',
      '        </div>',
      '        <div class="sbb-toolbar-group">',
      '          <span class="sbb-toolbar-label">Canvas</span>',
      '          <button type="button" class="sbb-button small" data-sbb="set-home">Set Home</button>',
      '          <button type="button" class="sbb-button small" data-sbb="reset-home">Reset Home</button>',
      '          <button type="button" class="sbb-button small sbb-info-toggle" data-sbb="toggle-info-overlay">Hide Info</button>',
      '        </div>',
      '      </div>',
      '    </div>',
      '    </div>',
      '    <div class="sbb-top-export-cta">',
      '      <button type="button" class="sbb-button sbb-button-export-hero" data-sbb="export-pdf">Export and Print</button>',
      '    </div>',
      '  </div>',
      '  <div class="sbb-mobile-tabs" data-sbb="mobile-tabs">',
      '    <button type="button" class="sbb-button xs" data-sbb="tab-document">Document</button>',
      '    <button type="button" class="sbb-button xs active" data-sbb="tab-canvas">Canvas</button>',
      '    <button type="button" class="sbb-button xs" data-sbb="tab-edit">Edit</button>',
      '  </div>',
      '  <div class="sbb-layout">',
      '    <aside class="sbb-controls sbb-controls--left" data-sbb-panel="document">',
      '      <div class="sbb-controls-main">',
        '        <section class="sbb-controls-group sbb-controls-group--primary">',
          '          <div class="sbb-left-panel-head">',
            '            <h2>Document Settings</h2>',
          '          </div>',
        '        </section>',
      '      </div>',
      '      <div class="sbb-controls-advanced sbb-doc-settings-menu" data-sbb="advanced-controls">',
      '',
      '      <section class="sbb-block">',
        '        <div class="sbb-grid2">',
          '          <div class="sbb-field">',
            '            <label>Software Preset</label>',
            '            <select data-sbb="software-preset"></select>',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label>Target Family / Mode</label>',
            '            <select data-sbb="tag-family"></select>',
          '          </div>',
          '          <div class="sbb-field sbb-field--hidden-control">',
            '            <label>Tag Type</label>',
            '            <select data-sbb="tag-type" tabindex="-1" aria-hidden="true"></select>',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label>Tag Count (1+)</label>',
            '            <input data-sbb="tag-count" type="number" min="1" step="1" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label data-sbb-unit-label="tag-size">Tag Size (mm)</label>',
      '            <input data-sbb="tag-size" type="number" min="1" step="0.1" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label data-sbb-unit-label="spacing">Center Spacing (cm)</label>',
      '            <input data-sbb="spacing" type="number" min="0.1" step="0.1" />',
      '          </div>',
          '          <div class="sbb-field">',
            '            <label>Corner Anchor</label>',
            '            <select data-sbb="corner">',
      '              <option value="center">Center</option>',
      '              <option value="top-left">Top Left</option>',
      '              <option value="top-right">Top Right</option>',
      '              <option value="bottom-left">Bottom Left</option>',
      '              <option value="bottom-right">Bottom Right</option>',
      '            </select>',
      '          </div>',
          '          <div class="sbb-field">',
            '            <label>Layout Mode</label>',
            '            <div class="sbb-readout" data-sbb="layout-mode"></div>',
          '          </div>',
        '        </div>',
        '        <h3 class="sbb-h3 sbb-subgroup-title">Page Layout</h3>',
        '        <div class="sbb-grid2 sbb-grid2--tight">',
          '          <div class="sbb-field sbb-field--span2">',
            '            <label>Paper Size</label>',
            '            <select data-sbb="paper-size"></select>',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label>Orientation</label>',
            '            <select data-sbb="paper-orientation">',
              '              <option value="portrait">Portrait</option>',
              '              <option value="landscape">Landscape</option>',
            '            </select>',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label data-sbb-unit-label="unit-system">Units</label>',
            '            <select data-sbb="unit-system">',
              '              <option value="metric">Metric</option>',
              '              <option value="imperial">Imperial</option>',
            '            </select>',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label data-sbb-unit-label="corner-margin">Corner Margin (mm)</label>',
            '            <input data-sbb="corner-margin" type="number" min="0" step="0.1" />',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label data-sbb-unit-label="cut-margin">Cut Margin (cm)</label>',
            '            <input data-sbb="cut-margin" type="number" min="0" step="0.1" />',
          '          </div>',
          '          <div class="sbb-field">',
            '            <label data-sbb-unit-label="print-margin">Print Margin (mm)</label>',
            '            <input data-sbb="print-margin" type="number" min="0" step="0.1" />',
          '          </div>',
        '        </div>',
        '        <div class="sbb-note" data-sbb="preset-note"></div>',
      '      </section>',
      '',
      '      <section class="sbb-block">',
      '        <label class="sbb-toggle"><input data-sbb="snap-enabled" type="checkbox" /> Snap to grid</label>',
      '        <label class="sbb-toggle"><input data-sbb="show-placement-guides" type="checkbox" /> Show placement guides</label>',
      '        <div class="sbb-grid2">',
      '          <div class="sbb-field">',
      '            <label data-sbb-unit-label="snap-grid">Snap Grid Size (mm)</label>',
      '            <input data-sbb="snap-grid" type="number" min="0.1" step="0.1" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Grid Divisions</label>',
      '            <input data-sbb="snap-grid-divisions" type="number" min="1" max="16" step="1" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Default Font</label>',
      '            <select data-sbb="default-font"></select>',
      '          </div>',
      '        </div>',
      '      </section>',
      '',
      '      <details class="sbb-settings-menu sbb-debug-menu" data-sbb="advanced-debug-menu">',
      '        <summary>Advanced / Debug</summary>',
      '        <div class="sbb-debug-panel">',
      '      <section class="sbb-block">',
      '        <div class="sbb-field">',
      '          <label>Tag IDs</label>',
      '          <label class="sbb-toggle"><input data-sbb="filter-apriltag-centers" type="checkbox" /> Filter AprilTag IDs to clear centers</label>',
      '          <div class="sbb-ids" data-sbb="id-list"></div>',
      '          <div class="sbb-note" data-sbb="id-validity"></div>',
      '        </div>',
      '      </section>',
      '',
      '      <section class="sbb-block">',
      '        <div class="sbb-field">',
      '          <label>Offsets Between Tags (Auto Mode)</label>',
      '          <div class="sbb-steps" data-sbb="step-list"></div>',
      '        </div>',
      '      </section>',
      '',
      '      <section class="sbb-block">',
      '        <label class="sbb-toggle"><input data-sbb="show-grid" type="checkbox" /> Show reference bars</label>',
      '        <label class="sbb-toggle"><input data-sbb="show-distances" type="checkbox" /> Show distance labels</label>',
      '        <label class="sbb-toggle"><input data-sbb="show-reference-measurements" type="checkbox" /> Show reference measurements</label>',
      '        <div class="sbb-grid2">',
      '          <div class="sbb-field">',
      '            <label data-sbb-unit-label="checker-width">Checker Width (cm)</label>',
      '            <input data-sbb="checker-width" type="number" min="0.1" step="0.1" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label data-sbb-unit-label="checker-height">Checker Height (mm)</label>',
      '            <input data-sbb="checker-height" type="number" min="0.1" step="0.1" />',
      '          </div>',
      '        </div>',
      '        <div class="sbb-note" data-sbb="grid-ratio"></div>',
      '      </section>',
      '',
      '      <section class="sbb-block">',
      '        <h3 class="sbb-h3">Background</h3>',
      '        <div class="sbb-grid2">',
      '          <div class="sbb-field">',
      '            <label>Background Mode</label>',
      '            <select data-sbb="background-mode">',
      '              <option value="solid">Solid</option>',
      '              <option value="image">Image</option>',
      '            </select>',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Background Color</label>',
      '            <input data-sbb="background-color" type="color" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Background Image</label>',
      '            <input data-sbb="background-file" type="file" accept="image/*" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Background Opacity</label>',
      '            <input data-sbb="background-opacity" type="number" min="0" max="1" step="0.05" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label><input data-sbb="background-noise-enabled" type="checkbox" /> Background Noise</label>',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label data-sbb-unit-label="background-noise-size">Noise Grain Size (mm)</label>',
      '            <input data-sbb="background-noise-size" type="number" min="0.1" max="8" step="0.1" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Noise Contrast</label>',
      '            <input data-sbb="background-noise-contrast" type="number" min="0" max="1" step="0.05" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Noise Color A</label>',
      '            <input data-sbb="background-noise-color-a" type="color" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Noise Color B</label>',
      '            <input data-sbb="background-noise-color-b" type="color" />',
      '          </div>',
      '        </div>',
      '      </section>',
      '',
      '      <section class="sbb-block" data-sbb="template-export-panel">',
      '        <h3 class="sbb-h3">Template Export</h3>',
      '        <div class="sbb-grid2">',
      '          <div class="sbb-field">',
      '            <label>Template ID</label>',
      '            <input data-sbb="template-export-id" type="text" placeholder="rc-a4-2tag-horizontal" />',
      '          </div>',
      '          <div class="sbb-field">',
      '            <label>Template Name</label>',
      '            <input data-sbb="template-export-name" type="text" placeholder="RC A4 2-Tag Horizontal" />',
      '          </div>',
      '        </div>',
      '        <div class="sbb-field">',
      '          <label>Description (optional)</label>',
      '          <input data-sbb="template-export-description" type="text" placeholder="Short description" />',
      '        </div>',
      '        <div class="sbb-actions small">',
      '          <button type="button" class="sbb-button secondary" data-sbb="template-copy-details">Copy Template Details</button>',
      '        </div>',
      '        <div class="sbb-field">',
      '          <label>Template JSON</label>',
      '          <textarea class="sbb-template-export-output" data-sbb="template-export-output" readonly></textarea>',
      '        </div>',
      '      </section>',
      '',
      '      <section class="sbb-block">',
      '        <div class="sbb-actions">',
      '          <button type="button" class="sbb-button secondary" data-sbb="show-guide-advanced">In-Depth Guide</button>',
      '          <button type="button" class="sbb-button secondary" data-sbb="download-design">Download Design</button>',
      '          <button type="button" class="sbb-button secondary" data-sbb="upload-design">Upload Design</button>',
      '          <button type="button" class="sbb-button secondary" data-sbb="export-png">Export PNG</button>',
      '          <input data-sbb="import-design-file" type="file" accept=".json,.sbb.json,application/json" hidden />',
      '        </div>',
      '        <div class="sbb-status" data-sbb="status"></div>',
      '      </section>',
      '        </div>',
      '      </details>',
      '      </div>',
      '      <section class="sbb-controls-group sbb-controls-group--command">',
      '        <div class="sbb-command-output">',
      '          <div class="sbb-command-output-head">',
      '            <label class="sbb-command-output-label" for="sbb-command-output-field">Photogrammetry Command Output</label>',
      '            <div class="sbb-command-output-controls">',
      '              <button type="button" class="sbb-button small xs" data-sbb="download-tag-csv">Download CSV</button>',
      '              <button type="button" class="sbb-button small xs" data-sbb="download-metashape-py">Download .py</button>',
      '              <button type="button" class="sbb-button small xs" data-sbb="realityscan-output-mode">Ground Control</button>',
      '              <div class="sbb-command-output-unit-row">',
      '                <label for="sbb-command-unit-field">1 unit =</label>',
      '                <select id="sbb-command-unit-field" data-sbb="command-unit-mode"></select>',
      '              </div>',
      '            </div>',
      '          </div>',
      '          <textarea id="sbb-command-output-field" class="sbb-command-output-text" data-sbb="command-output" readonly wrap="off" spellcheck="false"></textarea>',
      '          <div class="sbb-used-tags-wrap">',
      '            <div class="sbb-used-tags-head">',
      '              <label class="sbb-command-output-label" for="sbb-used-tags-field">Used Tag List (CSV)</label>',
      '              <div class="sbb-used-tags-actions">',
      '                <button type="button" class="sbb-button small xs secondary" data-sbb="upload-ignore-csv">Upload Ignore CSV</button>',
      '                <input data-sbb="ignore-csv-file" type="file" accept=".csv,text/csv" hidden />',
      '              </div>',
      '            </div>',
      '            <textarea id="sbb-used-tags-field" class="sbb-command-output-text sbb-used-tags-text" data-sbb="used-tag-csv" readonly wrap="off" spellcheck="false"></textarea>',
      '          </div>',
      '        </div>',
      '      </section>',
      '    </aside>',
      '',
      '    <section class="sbb-canvas-wrap" data-sbb-panel="canvas">',
      '      <div class="sbb-canvas-meta">',
      '        <div data-sbb="paper-info"></div>',
      '        <div data-sbb="warnings"></div>',
      '      </div>',
      '      <canvas class="sbb-canvas" data-sbb="canvas"></canvas>',
      '      <textarea class="sbb-inline-text-editor" data-sbb="inline-text-editor"></textarea>',
      '    </section>',
      '',
      '    <aside class="sbb-controls sbb-controls--right" data-sbb-panel="edit">',
      '      <section class="sbb-controls-group sbb-controls-group--additem">',
      '        <h3 class="sbb-h3">Add Item</h3>',
      '        <div class="sbb-right-add-grid">',
      '          <button type="button" class="sbb-button small" data-sbb="add-reference-right">Reference</button>',
      '          <button type="button" class="sbb-button small" data-sbb="add-text-right">Text</button>',
      '          <button type="button" class="sbb-button small" data-sbb="add-image-right">Image</button>',
      '          <button type="button" class="sbb-button small" data-sbb="add-tag-right">Tag</button>',
      '          <select class="sbb-select xs" data-sbb="add-shape-kind-right"></select>',
      '          <button type="button" class="sbb-button small" data-sbb="add-shape-right">Shape</button>',
      '        </div>',
      '      </section>',
      '      <section class="sbb-controls-group sbb-controls-group--layers">',
      '        <details class="sbb-settings-menu sbb-layers-menu" data-sbb="layers-menu" open>',
      '          <summary>Layers</summary>',
      '          <div class="sbb-layers-panel" data-sbb="layers-panel"></div>',
      '        </details>',
      '      </section>',
      '      <section class="sbb-controls-group sbb-controls-group--context">',
      '        <details class="sbb-settings-menu sbb-properties-menu" data-sbb="properties-menu" open>',
      '          <summary>Properties</summary>',
      '          <div class="sbb-selection-shelf" data-sbb="selection-shelf"></div>',
      '          <div class="sbb-inspector" data-sbb="inspector"></div>',
      '        </details>',
      '      </section>',
      '    </aside>',
      '',
      '    <div class="sbb-image-picker-overlay" data-sbb="image-picker-overlay" hidden>',
      '      <div class="sbb-image-picker-backdrop" data-sbb="image-picker-dismiss"></div>',
      '      <section class="sbb-image-picker-card" data-sbb="image-picker-card" role="dialog" aria-modal="true" aria-label="Add image">',
      '        <div class="sbb-image-picker-title">Add Image</div>',
      '        <div class="sbb-image-picker-modes">',
      '          <button type="button" class="sbb-button small active" data-sbb="image-picker-mode-upload">Upload</button>',
      '          <button type="button" class="sbb-button small" data-sbb="image-picker-mode-url">Paste URL</button>',
      '        </div>',
      '        <div class="sbb-image-picker-panel" data-sbb="image-picker-upload-panel">',
      '          <input data-sbb="image-picker-file" type="file" accept="image/*" />',
      '          <p class="sbb-image-picker-note">Local uploads are not persisted in templates/share links.</p>',
      '        </div>',
      '        <div class="sbb-image-picker-panel" data-sbb="image-picker-url-panel" hidden>',
      '          <div class="sbb-image-picker-url-row">',
      '            <input data-sbb="image-picker-url-input" type="url" placeholder="https://example.com/image.png" />',
      '            <button type="button" class="sbb-button small secondary" data-sbb="image-picker-url-preview">Preview</button>',
      '          </div>',
      '          <p class="sbb-image-picker-note">URL images persist in templates/share links (subject to CORS for export).</p>',
      '        </div>',
      '        <div class="sbb-image-picker-preview-wrap">',
      '          <img class="sbb-image-picker-preview" data-sbb="image-picker-preview" alt="Image preview" hidden />',
      '          <div class="sbb-image-picker-preview-empty" data-sbb="image-picker-preview-empty">Select a file or paste a URL, then preview.</div>',
      '        </div>',
      '        <div class="sbb-image-picker-status" data-sbb="image-picker-status"></div>',
      '        <div class="sbb-image-picker-actions">',
      '          <button type="button" class="sbb-button small secondary" data-sbb="image-picker-cancel">Cancel</button>',
      '          <button type="button" class="sbb-button small primary" data-sbb="image-picker-insert" disabled>Insert</button>',
      '        </div>',
      '      </section>',
      '    </div>',
      '',
      '    <div class="sbb-export-overlay" data-sbb="export-overlay" hidden>',
      '      <div class="sbb-export-backdrop" data-sbb="export-dismiss"></div>',
      '      <section class="sbb-export-card" data-sbb="export-card" role="dialog" aria-modal="true" aria-label="Export and Print">',
      '        <div class="sbb-export-title">Export and Print</div>',
      '        <div class="sbb-export-layout">',
      '          <div class="sbb-export-preview-wrap">',
      '            <canvas class="sbb-export-preview-canvas" data-sbb="export-preview-canvas" width="500" height="700"></canvas>',
      '          </div>',
      '          <div class="sbb-export-options">',
      '            <div class="sbb-grid2">',
              '              <div class="sbb-field">',
                '                <label>Print DPI</label>',
                '                <div class="sbb-export-dpi-row">',
                '                  <input data-sbb="export-pdf-dpi" type="number" min="96" max="1200" step="1" />',
                '                  <select data-sbb="export-pdf-dpi-preset">',
                '                    <option value="">Preset</option>',
                '                    <option value="96">96</option>',
                '                    <option value="150">150</option>',
                '                    <option value="200">200</option>',
                '                    <option value="300">300</option>',
                '                    <option value="600">600</option>',
                '                    <option value="720">720</option>',
                '                    <option value="1200">1200</option>',
                '                  </select>',
                '                </div>',
                '              </div>',
      '              <div class="sbb-field">',
      '                <label>Export Mode</label>',
      '                <select data-sbb="export-pdf-mode">',
      '                  <option value="hybrid-vector">Hybrid Vector</option>',
      '                  <option value="bitmap">Bitmap</option>',
      '                </select>',
      '              </div>',
      '              <div class="sbb-field">',
      '                <label>Format</label>',
      '                <select data-sbb="export-format">',
      '                  <option value="pdf">PDF</option>',
      '                  <option value="png">PNG</option>',
      '                  <option value="jpg">JPG</option>',
      '                </select>',
      '              </div>',
      '            </div>',
      '            <div class="sbb-note sbb-export-effective-dpi" data-sbb="export-pdf-effective-dpi"></div>',
      '            <div class="sbb-export-warning">',
      '              <strong>Print Scale Warning</strong>',
      '              <p>You must set printer scaling to <em>Actual Size</em> or <em>100%</em>.</p>',
      '              <p>Any other scaling will produce incorrect measurement output.</p>',
      '            </div>',
      '            <div class="sbb-export-status" data-sbb="export-preview-status"></div>',
      '            <div class="sbb-export-command-wrap">',
      '              <label class="sbb-command-output-label" for="sbb-export-command-output-field">Photogrammetry Command Output</label>',
      '              <textarea id="sbb-export-command-output-field" class="sbb-command-output-text sbb-export-command-output" data-sbb="export-command-output" readonly wrap="off" spellcheck="false"></textarea>',
      '            </div>',
      '            <div class="sbb-export-actions">',
      '              <button type="button" class="sbb-button small secondary" data-sbb="export-cancel">Cancel</button>',
      '              <button type="button" class="sbb-button small primary" data-sbb="export-confirm">Export</button>',
      '            </div>',
      '          </div>',
      '        </div>',
      '      </section>',
      '    </div>',
      '',
      '    <div class="sbb-guide-overlay" data-sbb="guide-overlay" hidden>',
      '      <div class="sbb-guide-backdrop" data-sbb="guide-dismiss"></div>',
      '      <div class="sbb-guide-spotlight" data-sbb="guide-spotlight"></div>',
      '      <section class="sbb-guide-card" data-sbb="guide-card" role="dialog" aria-modal="true" aria-label="Scale Bar Builder guide">',
      '        <div class="sbb-guide-meta" data-sbb="guide-step-index">Step 1 of 1</div>',
      '        <h3 class="sbb-guide-title" data-sbb="guide-title"></h3>',
      '        <div class="sbb-guide-body" data-sbb="guide-body"></div>',
      '        <div class="sbb-guide-actions">',
      '          <button type="button" class="sbb-button small" data-sbb="guide-back">Back</button>',
      '          <button type="button" class="sbb-button small primary" data-sbb="guide-next">Next</button>',
      '          <button type="button" class="sbb-button small secondary" data-sbb="guide-skip">Skip</button>',
      '        </div>',
      '      </section>',
      '    </div>',
      '  </div>',
      '</div>'
    ].join('\n');
  }

  
  sbbNamespace.createTemplate = createTemplate;
})();
